import { render, staticRenderFns } from "./LtkProfileHeader.vue?vue&type=template&id=0412b1b6&scoped=true"
import script from "./LtkProfileHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LtkProfileHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LtkProfileHeader.vue?vue&type=style&index=0&id=0412b1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412b1b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkShopAvatar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkShopAvatar.vue').default,FollowLtkFollowButton: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Follow/LtkFollowButton.vue').default,CreatorShopLink: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopLink.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default})
